import React from "react";
import { PARAMETER_OPTIONS } from "../../constants";
import Select from "./select";

const {
  SETS,
  ROUNDS,
  REPS,
  RPE,
  RPEAMRAP,
  TIME,
  DISTANCE,
  LOAD,
  REST,
  VELOCITY,
  FREEFORM,
  NONE,
} = PARAMETER_OPTIONS;

function SelectParameters({
  value,
  index,
  handleChange,
  form,
  intensityMeasure,
}) {
  return (
    <>
      <Select
        name={`parameter${index}`}
        className="select-input"
        options={[
          NONE,
          SETS,
          ROUNDS,
          REPS,
          RPEAMRAP,
          TIME,
          DISTANCE,
          LOAD,
          REST,
          VELOCITY,
          FREEFORM,
        ].map((parameter) => {
          return {
            text: [RPE, RPEAMRAP].includes(parameter)
              ? intensityMeasure
              : parameter,
            value: parameter,
          };
        })}
        value={value}
        onChange={(val) =>
          handleChange({ target: { name: `parameter${index}`, value: val } })
        }
        disabled={false}
      />
    </>
  );
}

export default SelectParameters;
